import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=829016f0&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829016f0",
  null
  
)

export default component.exports